var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21181 12.638C3.88079 12.638 3.59752 12.5203 3.36199 12.2847C3.12647 12.0492 3.0085 11.7657 3.0081 11.4343V3.61024H2.40625V2.40654H5.41551V1.80469H9.02662V2.40654H12.0359V3.61024H11.434V11.4343C11.434 11.7653 11.3163 12.0488 11.0807 12.2847C10.8452 12.5207 10.5617 12.6384 10.2303 12.638H4.21181ZM5.41551 10.2306H6.61921V4.81395H5.41551V10.2306ZM7.82292 10.2306H9.02662V4.81395H7.82292V10.2306Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFill);
export default __webpack_public_path__ + "static/media/delete-fill.491cfc2eb9f86b1db63a677d719c360f.svg";
export { ForwardRef as ReactComponent };